/* NZS Alpine health - keeps the storefront usable even if Alpine fails to boot.
   (1) first-error capture (diagnose crashes on the password-gated store),
   (2) blank-page watchdog: if Alpine never initialises, reveal the content it would have shown.
   Loaded early (defer, before vendors.js) from layout/theme.liquid. No deps. */
(function () {
  if (window.__nzsHealth) return; window.__nzsHealth = 1;
  if (window.Shopify && Shopify.designMode) return;   // never touch the theme-editor canvas

  /* (1) record the FIRST error - readable via <html data-nzs-firsterr> even when pw-gated */
  var logged = false;
  var hardErr = false;    // real script/promise error, NOT a benign resource 404
  var rescueTries = 0;
  function note(kind, msg, src, ln, col) {
    if (logged) return; logged = true;
    var s = (kind + ': ' + (msg || '') + (src ? (' @' + src + ':' + (ln || '') + ':' + (col || '')) : '')).slice(0, 300);
    try { document.documentElement.setAttribute('data-nzs-firsterr', s); } catch (e) {}
    try { console.error('[nzs-health] first error:', s); } catch (e) {}
  }
  window.addEventListener('error', function (e) {
    if (e.target === window) hardErr = true;   // resource 404s have e.target = the img/script/link, not window
    note('error', e.message, e.filename, e.lineno, e.colno);
  }, true);
  window.addEventListener('unhandledrejection', function (e) {
    hardErr = true;
    note('promise', (e.reason && e.reason.message) || String(e.reason));
  });

  /* (2) blank-page watchdog - Alpine v3 marks initialised x-data roots with _x_dataStack; the <body>
     carries x-data in this theme, so a missing stack after the window means Alpine never booted. */
  function booted() { return !!(document.body && document.body._x_dataStack); }
  function rescue() {
    if (booted()) return;                              // Alpine fine -> no-op (zero impact on normal loads)
    if (document.hidden) return;                       /* NZS: never rescue a hidden tab (rAF paused -> Alpine boots on focus) */
    if (window.Alpine && !hardErr && rescueTries < 4) { /* NZS: Alpine present + no HARD error -> just slow; wait, don't false-rescue */
      rescueTries++; setTimeout(rescue, 3000); return;
    }
    try {
      document.querySelectorAll('[x-cloak]').forEach(function (el) { el.removeAttribute('x-cloak'); });
      document.querySelectorAll('.anm-move-up').forEach(function (el) { el.classList.add('active-anm-heading'); });
      document.querySelectorAll('.animate_transition_card__image').forEach(function (el) { el.classList.add('active', 'lazy_active'); });
      document.documentElement.setAttribute('data-nzs-rescued', '1');
      try { console.warn('[nzs-health] Alpine did not boot - content revealed by watchdog'); } catch (e) {}
    } catch (e) {}
  }
  /* NZS card image/cloak sweep - ALWAYS runs (even when Alpine DID boot) to catch PARTIAL boots:
     un-cloak collection card slideshows + reveal any card image that loaded but missed its inline onload. */
  /* reveal one card image that finished loading but missed its inline onload (eager/cached/bfcache). */
  function revealImg(im) {
    if (im && im.complete && im.naturalWidth > 0 && im.classList.contains('skeleton-image')) {
      im.classList.remove('animate-Xpulse', 'skeleton-image'); im.classList.add('img-loaded', 'active');
    }
  }
  function cardSweep() {
    try {
      document.querySelectorAll('.card-product [id^="x-slideshow-card-product-"][x-cloak]').forEach(function (el) { el.removeAttribute('x-cloak'); });
      document.querySelectorAll('.card-product img.skeleton-image').forEach(revealImg);
    } catch (e) {}
  }
  /* per-image: catch every card image the instant it loads - eager, lazy-on-scroll, infinite-scroll. */
  document.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.classList.contains('skeleton-image') && t.closest('.card-product')) revealImg(t);
  }, true);
  function arm() { setTimeout(rescue, 3000); setTimeout(cardSweep, 1200); }   // rescue=total-boot-fail; cardSweep=always
  document.addEventListener('visibilitychange', function () {   /* NZS: tab focused -> rAF resumes + Alpine boots; re-check so no false rescue */
    if (document.hidden) return;
    cardSweep();
    if (!booted()) setTimeout(rescue, 1500);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
  window.addEventListener('load', cardSweep);
  window.addEventListener('pageshow', cardSweep);   // Back/bfcache restore - no other handler re-fires
})();
